module.exports = __webpack_public_path__ + "static/deskAnimation-ec445c024864299a2d049d03a451b82a.svg";